<template>

<core-config-section :locked="!loggedin">

	<h2>H-index Exclude</h2>

	<p class="about">You can exclude specific games from being included in your h-index calculations.</p>

	<div class="inputs">

		<core-filter-input-suggest placeholder="Start typing a game's name to exclude..." field="name" source="plays" filter="config/insights/hindex/exclude" api="games/suggest" data="games" />

	</div>

</core-config-section>

</template>

<script>

export default {

}

</script>